import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import {
  reviewQueueKey,
} from 'components/ReviewQueue/reviewQueueKey';
import type { ReviewQueueItem } from 'components/ReviewQueue/reviewQueueTypes';

export function useReviewQueue(incidentId: string | null) {
  return useQuery({
    queryKey: [...reviewQueueKey, incidentId ?? 'hub'],
    queryFn: async () => {
      const response = await axios.get<{ items: ReviewQueueItem[] }>(
        `${config.apiGateway.approvals}/mine`,
        {
          params: incidentId ? { incidentId } : undefined,
        }
      );
      return response.data.items;
    },
  });
}
